class FeatureColumns extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.breakpoint = 768;
  }

  connectedCallback() {
    this.init();
    window.addEventListener('resize', this.init.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.init.bind(this));
    this.destroy();
  }

  init() {
    const windowInnerWidth = window.innerWidth - 8;
    const isMobile = windowInnerWidth < this.breakpoint;

    if (isMobile && !this.swiper) {
      const next = this.querySelector('.feature-columns__button--next');
      const prev = this.querySelector('.feature-columns__button--prev');

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: next,
          prevEl: prev
        }
      });
    }

    if (!isMobile && this.swiper) {
      this.destroy();
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('feature-columns', FeatureColumns);
